import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_248: DocMigration = {
  maxSchemaVersion: "0.0.248",
  description: "Default exteriorCamera eyeLevel should be 5ft8in not 10ft",
  apply(json: any) {
    for (const elevation of Object.values<any>(json.elevations)) {
      if (elevation.defaultExteriorCamera?.eyeLevel === 120) {
        elevation.defaultExteriorCamera.eyeLevel = 68;
      }
      if (elevation.topLeftPerspectiveCamera?.eyeLevel === 120) {
        elevation.topLeftPerspectiveCamera.eyeLevel = 68;
      }
      if (elevation.topRightPerspectiveCamera?.eyeLevel === 120) {
        elevation.topRightPerspectiveCamera.eyeLevel = 68;
      }
      if (elevation.bottomLeftPerspectiveCamera?.eyeLevel === 120) {
        elevation.bottomLeftPerspectiveCamera.eyeLevel = 68;
      }
      if (elevation.bottomRightPerspectiveCamera?.eyeLevel === 120) {
        elevation.bottomRightPerspectiveCamera.eyeLevel = 68;
      }
    }
    return json;
  },
};

export default migration_0_0_248;
